import { Icon, IconProps } from '@chakra-ui/icons';
import React from 'react';

export const CollectInfo = (props: IconProps) => (
  <Icon width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7 13.1624C10.3 13.1624 13 10.4624 13 7.16235C13 3.86235 10.3 1.16235 7 1.16235C3.7 1.16235 1 3.86235 1 7.16235C1 10.4624 3.7 13.1624 7 13.1624Z"
      stroke="black"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.2 9.66238C6.2 10.1042 6.55817 10.4624 7 10.4624C7.44183 10.4624 7.8 10.1042 7.8 9.66238V6.36375C7.8 5.92193 7.44183 5.56375 7 5.56375C6.55817 5.56375 6.2 5.92193 6.2 6.36375V9.66238ZM6.2 4.65964C6.2 5.1021 6.56183 5.4569 7 5.4569C7.43817 5.4569 7.8 5.1021 7.8 4.65964C7.8 4.21719 7.43817 3.86238 7 3.86238C6.56183 3.86238 6.2 4.21719 6.2 4.65964Z"
      fill="white"
      stroke="black"
      strokeWidth="0.6"
    />
  </Icon>
);
